import React from 'react';
import PropTypes from 'prop-types';
import { getFlatRoutes } from 'helpers/utils';
import NavbarNavLink from './NavbarNavLink';

const NavbarDropdownPages = ({ items }) => {
  const routes = getFlatRoutes(items);

  return (
    <>
      <div className="tw-grid tw-grid-cols-12 tw-gap-4">
        <div className="tw-col-span-6 2xl:tw-col-span-3">
          <div className="tw-flex tw-flex-col">
            <NavbarNavLink title="Simple Auth" />
            {routes.authentication.slice(0, 7).map(route => (
              <NavbarNavLink key={route.name} route={route} />
            ))}
          </div>
        </div>
        <div className="tw-col-span-6 2xl:tw-col-span-3">
          <div className="tw-flex tw-flex-col">
            <NavbarNavLink title="Card Auth" />
            {routes.authentication.slice(7, 14).map(route => (
              <NavbarNavLink key={route.name} route={route} />
            ))}
          </div>
        </div>
        <div className="tw-col-span-6 2xl:tw-col-span-3">
          <div className="tw-flex tw-flex-col">
            <NavbarNavLink title="Split Auth" />
            {routes.authentication.slice(14, 21).map(route => (
              <NavbarNavLink key={route.name} route={route} />
            ))}
          </div>
        </div>
        <div className="tw-col-span-6 2xl:tw-col-span-3">
          <div className="tw-flex tw-flex-col">
            <NavbarNavLink title="Other Auth" />
            {routes.authentication.slice(21, 23).map(route => (
              <NavbarNavLink key={route.name} route={route} />
            ))}
            <NavbarNavLink title="Miscellaneous" />
            {routes.miscellaneous.map(route => (
              <NavbarNavLink key={route.name} route={route} />
            ))}
          </div>
        </div>
      </div>
      <div className="tw-grid tw-grid-cols-12 tw-gap-4">
        <div className="tw-col-span-6 2xl:tw-col-span-3">
          <div className="tw-flex tw-flex-col">
            <NavbarNavLink title="User" />
            {routes.user.map(route => (
              <NavbarNavLink key={route.name} route={route} />
            ))}
          </div>
        </div>
        <div className="tw-col-span-6 2xl:tw-col-span-3">
          <div className="tw-flex tw-flex-col">
            <NavbarNavLink title="Pricing" />
            {routes.pricing.map(route => (
              <NavbarNavLink key={route.name} route={route} />
            ))}
          </div>
        </div>
        <div className="tw-col-span-6 2xl:tw-col-span-3">
          <div className="tw-flex tw-flex-col">
            <NavbarNavLink title="Errors" />
            {routes.errors.map(route => (
              <NavbarNavLink key={route.name} route={route} />
            ))}
          </div>
        </div>
        <div className="tw-col-span-6 2xl:tw-col-span-3">
          <div className="tw-flex tw-flex-col">
            <NavbarNavLink title="Others" />
            {routes.unTitled.map(route => (
              <NavbarNavLink key={route.name} route={route} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

NavbarDropdownPages.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      name: PropTypes.string.isRequired,
      to: PropTypes.string,
      children: PropTypes.array
    }).isRequired
  ).isRequired
};

export default NavbarDropdownPages;
